import {createSelector} from "reselect";

const selectCart = state => state.cart;

export const selectInternalOrExternal = createSelector(
    [selectCart],
    cart => cart.productFor
);
export const selectInstallation = createSelector(
    [selectCart],
    cart => cart.installation
);
export const selectPrice = createSelector(
    [selectCart],
    cart => cart.price
);
export const selectPortal = createSelector(
    [selectCart],
    cart => cart.portal
);